import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { formatNoDecimalBigInt } from '@atheneum/api/dist/lib'

class PerformanceTable extends Component {
  static propTypes = {
    performances: PropTypes.object,
    sidebarStore: PropTypes.object,
    showTotal: PropTypes.bool
  }

  render() {
    const { performances } = this.props
    const { totalTargetMargin, totalCost, totalFee } = performances.reduce((total, performance) => {
      total['totalTargetMargin'] += performance.revenue - performance.cost
      total['totalCost'] += performance.cost
      total['totalFee'] += performance.revenue
      return total
    }, {
      totalTargetMargin: 0,
      totalCost: 0,
      totalFee: 0
    })

    return (
      <table className='table-wrapper performance-report-table'>
        <thead>
          <tr>
            <th>Employee name</th>
            <th>Project name</th>
            <th>Account manager</th>
            <th>Deliverable</th>
            <th>Expert name</th>
            <th>Fee type</th>
            <th>Fee</th>
            <th>Cost</th>
            <th>
              <div className='table-number'>Margin (EUR)</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {performances.map(performance => {
            return (
              <tr key={performance.id}>
                <td>
                  <span className='text-wrapper'>
                    {performance.employeeFullName}{' '}
                    {performance.isNewAssociate ? 'NH' : ''}
                  </span>
                </td>
                <td>
                  <span
                    className='row--link'
                    onClick={() =>
                      this.props.sidebarStore.openSidebar({
                        template: 'project',
                        id: performance.projectId
                      })
                    }
                  >
                    {performance.projectName}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {performance.accountManagerFullName}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {performance.deliverable}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {performance.expertFullName || '—'}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>{performance.feeType}</span>
                </td>
                <td>
                  <div className='table-number'>
                    {formatNoDecimalBigInt(
                      performance.revenue
                    )}
                  </div>
                </td>
                <td>
                  <div className='table-number'>
                    {formatNoDecimalBigInt(
                      performance.cost
                    )}
                  </div>
                </td>
                <td>
                  <div className='table-number'>
                    {formatNoDecimalBigInt(
                      performance.revenue - performance.cost
                    )}
                  </div>
                </td>
              </tr>
            )
          })}
          {this.props.showTotal && (
            <tr className='totals'>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td>
                <strong>Total</strong>
              </td>
              <td>
                <div className='table-number'>
                  {formatNoDecimalBigInt(totalFee)}
                </div>
              </td>
              <td>
                <div className='table-number'>
                  {formatNoDecimalBigInt(totalCost)}
                </div>
              </td>
              <td>
                <div className='table-number'>
                  {formatNoDecimalBigInt(totalTargetMargin)}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )
  }
}

export default inject('sidebarStore')(observer(PerformanceTable))
